import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M20.692 8.5q.714 0 1.26.547.549.548.548 1.26v1.616q0 .157-.04.337-.041.18-.09.336l-2.867 6.763q-.215.48-.72.81a1.9 1.9 0 0 1-1.056.331H7.212v-12l5.817-5.767a1.206 1.206 0 0 1 1.442-.221q.36.192.527.546t.071.732L13.992 8.5zm-11.98.638V19h9.019q.105 0 .216-.058a.37.37 0 0 0 .168-.192L21 12v-1.692a.3.3 0 0 0-.087-.222.3.3 0 0 0-.22-.086h-8.597l1.254-5.48zM4.307 20.5a1.74 1.74 0 0 1-1.277-.531 1.74 1.74 0 0 1-.531-1.277v-8.384q0-.746.531-1.277A1.74 1.74 0 0 1 4.308 8.5h2.904V10H4.308a.3.3 0 0 0-.221.086.3.3 0 0 0-.087.222v8.384a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h2.905v1.5z"
    }, null, -1)
  ])))
}
export default { render: render }